/**
 * Replaces currency codes with symbols:
 * - "AED" → UAE Dirham Unicode symbol (د.إ)
 * - "SAR" → Saudi Riyal SVG symbol
 * - "ريال سعودي" / "ر.س" (Arabic) → same SAR SVG (e.g. when Arabic locale shows Arabic currency)
 * Runs on load, cart drawer open, cart update, and when new nodes are added (MutationObserver).
 */
(function () {
  const CURRENCY_SAR = 'SAR';
  const CURRENCY_AED = 'AED';
  const CURRENCY_SAR_AR = '\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A'; // ريال سعودي
  const CURRENCY_SAR_AR_SHORT = '\u0631.\u0633'; // ر.س
  const AED_SYMBOL = '\u062F.\u0625'; // د.إ (UAE Dirham)
  const SAR_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39" fill="currentColor" aria-hidden="true" class="currency-symbol-sar" style="display:inline-block;vertical-align:middle;width:1em;height:1em;margin:0 0.05em"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>';

  function shouldSkip(node) {
    const parent = node.parentElement;
    if (!parent) return true;
    const tag = parent.tagName && parent.tagName.toUpperCase();
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return true;
    if (parent.isContentEditable || (parent.tagName === 'INPUT' && parent.type === 'text')) return true;
    if (parent.closest && parent.closest('.cart__shipping-note')) return true;
    return false;
  }

  function replaceInNode(textNode, currencyCode, replacementHtml, ariaLabel) {
    if (textNode.nodeType !== Node.TEXT_NODE) return;
    if (shouldSkip(textNode)) return;

    let text = textNode.textContent || '';
    if (!text.includes(currencyCode)) return;

    const parts = text.split(currencyCode);
    if (parts.length < 2) return;

    const parent = textNode.parentNode;
    const fragment = document.createDocumentFragment();
    const isSar = currencyCode === CURRENCY_SAR || currencyCode === CURRENCY_SAR_AR || currencyCode === CURRENCY_SAR_AR_SHORT;
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].length) {
        fragment.appendChild(document.createTextNode(parts[i]));
      }
      if (i < parts.length - 1) {
        const span = document.createElement('span');
        span.className = isSar ? 'currency-symbol-sar-wrap' : 'currency-symbol-aed-wrap';
        if (ariaLabel) span.setAttribute('aria-label', ariaLabel);
        span.innerHTML = replacementHtml;
        fragment.appendChild(span);
      }
    }
    parent.replaceChild(fragment, textNode);
  }

  function replaceSarInNode(textNode) {
    let text = textNode.textContent || '';
    text = text
      .replace(/<span\s+class=['"]currency-symbol-sar-wrap['"][^>]*>.*?<\/span>/gi, CURRENCY_SAR)
      .replace(/<svg[\s\S]*?<\/svg>/gi, CURRENCY_SAR)
      .replace(/&lt;span\s+class=[\s\S]*?&lt;\/span&gt;/gi, CURRENCY_SAR);
    if (!text.includes(CURRENCY_SAR)) return;
    textNode.textContent = text;
    replaceInNode(textNode, CURRENCY_SAR, SAR_SVG, 'Saudi Riyal');
  }

  function replaceAedInNode(textNode) {
    let text = textNode.textContent || '';
    text = text.replace(/<span\s+class=['"]currency-symbol-aed-wrap['"][^>]*>.*?<\/span>/gi, CURRENCY_AED);
    if (!text.includes(CURRENCY_AED)) return;
    textNode.textContent = text;
    replaceInNode(textNode, CURRENCY_AED, AED_SYMBOL, 'UAE Dirham');
  }

  /** Replace Arabic "ريال سعودي" or "ر.س" with SAR symbol (Arabic locale on product cards) */
  function replaceSarArInNode(textNode) {
    let text = textNode.textContent || '';
    if (text.includes(CURRENCY_SAR_AR)) {
      textNode.textContent = text;
      replaceInNode(textNode, CURRENCY_SAR_AR, SAR_SVG, 'Saudi Riyal');
    } else if (text.includes(CURRENCY_SAR_AR_SHORT)) {
      textNode.textContent = text;
      replaceInNode(textNode, CURRENCY_SAR_AR_SHORT, SAR_SVG, 'Saudi Riyal');
    }
  }

  function replaceCurrencyInNode(textNode) {
    const t = textNode.textContent || '';
    if (t.includes(CURRENCY_AED)) replaceAedInNode(textNode);
    else if (t.includes(CURRENCY_SAR)) replaceSarInNode(textNode);
    else if (t.includes(CURRENCY_SAR_AR)) replaceSarArInNode(textNode);
    else if (t.includes(CURRENCY_SAR_AR_SHORT)) replaceSarArInNode(textNode);
  }

  function walkAndReplace(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        const t = node.textContent || '';
        return (t.includes(CURRENCY_AED) || t.includes(CURRENCY_SAR) || t.includes(CURRENCY_SAR_AR) || t.includes(CURRENCY_SAR_AR_SHORT)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    const toReplace = [];
    let n;
    while ((n = walker.nextNode())) toReplace.push(n);
    toReplace.forEach(replaceCurrencyInNode);
  }

  function run(root) {
    walkAndReplace(root || document.body);
  }

  function runOnCartDrawerOpen() {
    const drawer = document.querySelector('.cart-drawer');
    if (drawer) run(drawer);
  }

  // Expose for cart component to run immediately after section morph (avoids SAR→SVG flash)
  window.__replaceCartDrawerCurrency = runOnCartDrawerOpen;

  /* Re-run when lang attribute changes (e.g. after locale switch) */
  function observeLangForCurrency() {
    if (!document.documentElement) return;
    var langObs = new MutationObserver(function() {
      if ((document.documentElement.lang || '').toLowerCase().includes('ar')) {
        run();
        setTimeout(run, 300);
        setTimeout(run, 1000);
      }
    });
    langObs.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLangForCurrency);
  } else {
    observeLangForCurrency();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  // Use capture phase so we receive the event (it doesn't bubble from cart-drawer-component)
  document.addEventListener('dialog:open', (e) => {
    if (!e.target || !e.target.closest || !e.target.closest('.cart-drawer')) return;
    requestAnimationFrame(() => requestAnimationFrame(runOnCartDrawerOpen));
    setTimeout(runOnCartDrawerOpen, 150);
    setTimeout(runOnCartDrawerOpen, 500);
  }, true);

  document.addEventListener('cart:update', () => {
    runOnCartDrawerOpen();
    requestAnimationFrame(runOnCartDrawerOpen);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            walkAndReplace(node);
          } else if (node.nodeType === Node.TEXT_NODE) {
            replaceCurrencyInNode(node);
          }
        });
      }
    }
  });

  const observeWhenReady = () => {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      requestAnimationFrame(observeWhenReady);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWhenReady);
  } else {
    observeWhenReady();
  }
})();
